import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {IconArrowBack} from "../../../../../icons/IconArrowBack";
import {RegularCopyAlt} from "../../../../../icons/RegularCopyAlt";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import {FrameCorp} from "../../../../../components/FrameCorp";
import "./style.css";

export const CorporativoCard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();

  const handleButtonBack = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-corporativo-mobile${currentParams}`);
  };

  return (
      <div className="corporativo-card">
        <div className="overlap-wrapper-3">
          <div className="overlap-9">
            <header className="header-2">
              <div className="overlap-group-15">
                <div className="rectangle-15" />

                <div className="frame-43">
                  <FrameCorp color={colors.septimo} />
                </div>

                <div className="frame-44">
                  <div
                      className="icon-arrow-back-wrapper highlighted-button"
                      onClick={handleButtonBack}
                  >
                    <IconArrowBack className="icon-arrow-back-1" color="white" />
                  </div>

                  <div className="subtitle-2">Card details</div>
                </div>
              </div>
            </header>

            <div className="frame-45">
              <div className="frame-46">
                <div className="overlap-10">
                  <div
                      className="group-8"
                      style={{
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "contain",
                        backgroundImage: colors.url_card
                            ? `url(${colors.url_card})`
                            : "none",
                        backgroundColor: colors.url_card
                            ? "transparent"
                            : "#e8eaed",
                      }}
                  >
                    <div className="overlap-11">
                      <div className="group-9">
                        <div className="overlap-group-16"></div>
                      </div>

                      <div className="frame-47">
                        <div className="frame-48">
                          <div className="text-wrapper-45">Pay date</div>

                          <div className="text-wrapper-46">10 ABR</div>
                        </div>

                        <div className="frame-48">
                          <div className="text-wrapper-45">Due date</div>

                          <div className="text-wrapper-46">11/30</div>
                        </div>
                      </div>

                      <div className="frame-49">
                        <div className="text-wrapper-47">7531 4532 6643 5849</div>

                        <RegularCopyAlt className="regular-copy-alt-2" />
                      </div>
                    </div>
                  </div>

                  <div className="bottom-2">
                    <div className="fecha-pago-2">
                      <div className="text-wrapper-48">Available (USD)</div>

                      <div className="frame-50">
                        <div className="text-wrapper-49">13,000</div>
                      </div>
                    </div>

                    <div className="fecha-pago-2">
                      <div className="text-wrapper-48">Assigned (USD)</div>
                      <div className="frame-50">
                        <div className="text-wrapper-49">23,000</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="botonera-2">
                <div className="frame-51">
                  <img className="key" alt="Key" src="/img/key.svg" />

                  <div className="text-wrapper-53-quinto">CVV</div>
                </div>

                <div className="frame-51">
                  <div className="group-wrapper">
                    <div className="group-10">
                      <div className="overlap-group-17">
                        <img
                            className="vector-7"
                            alt="Vector"
                            src="/img/vector-5.svg"
                        />

                        <div className="frame-52">
                          <div className="ellipse-9" />

                          <div className="ellipse-10" />

                          <div className="ellipse-9" />
                        </div>

                        <img
                            className="vector-8"
                            alt="Vector"
                            src="/img/vector-6.svg"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-wrapper-53-quinto">PIN</div>
                </div>

                <div className="frame-51">
                  <img
                      className="frame-53"
                      alt="Frame"
                      src="/img/frame-1171274973.svg"
                  />

                  <div className="text-wrapper-53-quinto">Pay</div>
                </div>

                <div className="frame-54">
                  <img
                      className="group-wrapper"
                      alt="Regular menu dots"
                      src="/img/regular-menu-dots.svg"
                  />

                  <div className="text-wrapper-53-quinto">More</div>
                </div>
              </div>

              <div className="frame-55">
                <div className="tarjtetas-2">
                  <div className="title-4">Last Transactions</div>

                  <div className="frame-56">
                    <div className="btn-text-link-2">
                      <div className="text-wrapper-54">See all</div>

                      <img
                          className="img-3"
                          alt="Btn icon chevron"
                          src="/img/btn-icon-chevron-4.svg"
                      />
                    </div>
                  </div>
                </div>

                <div className="frame-57">
                  <div className="movements-3">
                    <div className="frame-58">
                      <img
                          className="img-3"
                          alt="Dinner"
                          src="/img/dinner-1.svg"
                      />

                      <div className="frame-50">
                        <div className="text-wrapper-55">
                          Starbucks coffee time
                        </div>

                        <img
                            className="img-3"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-5.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-59">
                      <div className="date-3">11/06/22</div>

                      <div className="amount-4">- $25.11</div>
                    </div>
                  </div>

                  <div className="movements-3">
                    <div className="frame-58">
                      <img className="img-3" alt="Paw" src="/img/paw-1.svg" />

                      <div className="frame-60">
                        <div className="text-wrapper-55">Bruno’s tricks</div>

                        <img
                            className="img-3"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-5.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-59">
                      <div className="date-3">11/06/22</div>

                      <div className="amount-4">- $12.42</div>
                    </div>
                  </div>

                  <div className="movements-3">
                    <div className="frame-58">
                      <img
                          className="shopping-bag-2"
                          alt="Shopping bag"
                          src="/img/shopping-bag-1.svg"
                      />

                      <div className="frame-50">
                        <div className="text-wrapper-55">New gymn shoes</div>

                        <img
                            className="img-3"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-5.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-59">
                      <div className="date-3">11/06/22</div>

                      <div className="amount-4">- $158.68</div>
                    </div>
                  </div>

                  <div className="movements-3">
                    <div className="frame-58">
                      <img
                          className="img-3"
                          alt="Dinner"
                          src="/img/dinner-1.svg"
                      />

                      <div className="frame-50">
                        <div className="text-wrapper-55">
                          Starbucks coffee time
                        </div>

                        <img
                            className="img-3"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-5.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-59">
                      <div className="date-3">11/06/22</div>

                      <div className="amount-4">- $25.11</div>
                    </div>
                  </div>

                  <div className="movements-3">
                    <div className="frame-58">
                      <img
                          className="shopping-bag-2"
                          alt="Shopping bag"
                          src="/img/shopping-bag-1.svg"
                      />

                      <div className="frame-50">
                        <div className="text-wrapper-55">New gymn shoes</div>

                        <img
                            className="img-3"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-5.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-59">
                      <div className="date-3">11/06/22</div>

                      <div className="amount-4">- $158.68</div>
                    </div>
                  </div>

                  <div className="movements-3">
                    <div className="frame-58">
                      <img
                          className="img-3"
                          alt="Credit card"
                          src="/img/credit-card-1.svg"
                      />

                      <div className="frame-60">
                        <div className="text-wrapper-55">Card payment</div>

                        <img
                            className="img-3"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-5.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-59">
                      <div className="date-3">11/06/22</div>

                      <div className="amount-5">$950.23</div>
                    </div>
                  </div>
                  <br></br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
